module.exports = __webpack_public_path__ + "static/media/dolphin.00392cba.png";